import { Skeleton } from '@/components/ui/skeleton';

export function PageSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <Skeleton style={{ height: 32, width: 240 }} />
      <Skeleton style={{ height: 16, width: 400 }} />
      <Skeleton style={{ height: 200, width: '100%' }} />
    </div>
  );
}
